import {
    faEllipsisVertical,
    faPlus,
    faFileCsv,
    faFileExport,
    faFileImport,
    faUser,
} from "@fortawesome/free-solid-svg-icons";
import {
    handleExportData,
} from "../../../Utils/helpers/commonhelper";
import { Filter } from "../../../pages/Filter";
import { FilterPagination } from "../../../pages/FIlterPagination";
import { DropdownItemWithActions } from "../../../pages/DropdownItemWithActions";
import { ColumnConfigurator } from "../../../pages/ColumnConfigurator";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useLocalStorageState from "use-local-storage-state";
import { DeleteRequest, GetRequest, PutRequest } from "../../../Utils/hooks/ApiHandler";
import { toast } from "sonner";
import { Button, Dropdown, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DeleteModal from "../../DeleteModal";
import useCommonData from "../../../Utils/actions/advanceFilteringAction";
import { ManageListDropdown } from "../../../pages/ManageListDropdown";

export const QuotationHeader = ({ heading, setHeading, quotationGrant, isMyApproval, setMyApproval, columnOptions, setActiveOffset, filterCategories, setFilterCategories, setColumns, columns, filterStates, setFilterState, setTempFilterData, setSearch }) => {
    const [customer, setCustomer] = useLocalStorageState("customer");
    const navigate = useNavigate();

    const customer_id = customer?.customer_details?.customer_id;
    const token = customer?.token?.authorization || "";
    const rf = customer?.token?.authentication || "";
    const extras = { customer, setCustomer, rf, navigate };
    const headers = {
        Authorization: token,
        Authentication: rf,
    };

    // state for heading to display
    const lastHeading = localStorage.getItem("quotation_last_heading");


    const [inputSearch, setInputSearch] = useState("");
    // isediting state for undoing the edit state in the filter name update in the heading dropdown
    const [editingId, setEditingId] = useState(false);
    // filter state to store the data to pass to delete and edit handler for filter
    const [filterData, setFilterData] = useState(null);
    // edit value state fot the filter card name edit
    const [editValue, setEditValue] = useState();
    // delete state for filter
    const [confirmFilterDelete, setFilterDelete] = useState(false);
    // filter seazrch bar input state
    const [filterSearchInput, setFilterSearchInput] = useState("");
    // fitered categories to store the search input filter categories
    const [filteredCategories, setFilteredCategories] = useState([]);
    // state for deals
    const [deals, setDeals] = useState([]);

    const [loading, setLoading] = useState(false)

    // Add states for filter pagination and search
    const [filterOffset, setFilterOffset] = useState(0);
    const [approvalCount, setApprovalCount] = useState(0);
    const [filterLimit, setFilterLimit] = useState(5);
    const [debouncedFilterSearch, setDebouncedFilterSearch] = useState("");
    const [filterPageCount, setFilterPageCount] = useState(0);
    // const [search, setSearch] = useState("");
    // state for filter dropdown of quotations
    const [filterDropdown, setFilterDropdown] = useState(false);

    // for dropdown of the filter cards being created by the user
    const [filterCategoriesDropdown, setFilterCategoriesDrop] = useState(false);
    const filterCategoriesDropRef = useRef(null);

    // common advance filter api calls that will be needed everywhere
    const { leadOwner, company, contacts } = useCommonData({
        leadOwner: true,
        leadSource: false,
        companies: true,
        contacts: true
    })

    const quotationStaticListOptions = [
        {
            key: "All Quotations",
            icon: <FontAwesomeIcon
                icon={faUser}
                style={{ width: "13px", height: "13px", marginRight: "9px" }}
            />
        },
    ]

    // filter dropdown options
    const dropdownOptions = [
        { value: "reference_number", label: "Reference Number" },
        { value: "contact_id", label: "Contact", option: contacts },
        { value: "deal_id", label: "Deal Name", option: deals },
        { value: "owner_id", label: "Owner", option: leadOwner },
        { value: "quotation_number", label: "Quotation Number" },
        { value: "company_id", label: "Company Name", option: company },
        { value: "quotation_date", label: "Quotation Date", type: "date-range" },
        { value: "expiry_date", label: "Expiry Date", type: "date-range" },
        { value: "created_at", label: "Created at", type: "date-range" },
    ];

    // sub filter dropdown option
    const subFilter = [
        { value: "equals", label: "Equals" },
        { value: "not_equals", label: "Not-Equals" },
        { value: "contains", label: "Contains" },
        { value: "not_contains", label: "Not-Contains" },
        { value: "in", label: "In" },
        { value: "not_in", label: "Not-In" },
        { value: "is_empty", label: "Is Empty" },
        { value: "is_not_empty", label: "Is Not Empty" },
        { value: "begins_with", label: "Begins With" },
        { value: "between", label: "Between" },
    ];
    const customSubFilter = [
        { value: "equals", label: "Equals" },
        { value: "not_equals", label: "Not-Equals" },
        { value: "is_set", label: "Is Set" },
        { value: "is_not_set", label: "Is Not Set" },
        { value: "in", label: "In" },
        { value: "not_in", label: "Not-In" },
    ];


    //list of import field
    const quotationImportFields = [
        { id: "contact_name", label: "Contact Name", required: true },
        { id: "reference", label: "Reference", required: true },
        { id: "quotation_date", label: "Quotation Date", required: true },
        { id: "expiry_date", label: "Expiry Date", required: true },
        { id: "owner", label: "Owner", required: true },
        { id: "deal_name", label: "Deal", required: true },
        { id: "description", label: "Short Description", required: true },
        { id: "product_services", label: "Product & Services", required: true },
        { id: "quantity", label: "Quantity", required: true },
        { id: "product_description", label: "Product Description", required: true },
        { id: "rate", label: "Rate", required: true },
        { id: "gst", label: "GST(%)", required: true },
        { id: "discount_type", label: "Discount Type", required: true },
        { id: "discount", label: "Discount", required: true },
        { id: "discount_amount", label: "Amount", required: true },
        { id: "sub_total", label: "Sub Total", required: true },
        { id: "grand_total", label: "Grand Total", required: true },
        { id: "special_discount", label: "Special Discount", required: false },
        { id: "special_discount_type", label: "Special Discount Type", required: false },
        { id: "special_discount_amount", label: "Special Discount Amount", required: false },
        { id: "shipping_charge", label: "Shipping Charge", required: false },
        { id: "gst_amount", label: "GST Amount", required: true },
        { id: "customer_note", label: "Customer Notes", required: false },
        { id: "terms_condition", label: "Terms & Conditions", required: false },
        { id: "billing_address", label: "Billing Address", required: false },
        { id: "billing_country", label: "Billing Country", required: false },
        { id: "billing_state", label: "Billing State", required: false },
        { id: "billing_city", label: "Billing City", required: false },
        { id: "billing_zipcode", label: "Billing Zipcode", required: false },
        { id: "shipping_address", label: "Shipping Address", required: false },
        { id: "shipping_country", label: "shipping Country", required: false },
        { id: "shipping_state", label: "shipping State", required: false },
        { id: "shipping_city", label: "shipping City", required: false },
        { id: "shipping_zipcode", label: "shipping Zipcode", required: false },
    ]

    useEffect(() => {
        const debounceTimer = setTimeout(() => {
            setSearch(inputSearch.trim());
            setActiveOffset(0);
        }, 300);
        return () => clearTimeout(debounceTimer);
    }, [inputSearch]);

    // isediting state for undoing the edit state in the filter name update in the heading dropdown
    // const [editingId, setEditingId] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedFilterSearch(filterSearchInput);
            setFilterOffset(0); // Reset to first page when search changes
        }, 300);

        return () => clearTimeout(timer);
    }, [filterSearchInput]);

    // we should create a useeffect that will make sure that if any input search is there then we will show the respective filter with respect to the input else if input is null then no input would be shown
    useEffect(() => {
        if (!filterSearchInput || filterSearchInput.trim() === "") {
            // If no search input, show all categories
            setFilteredCategories(filterCategories);
        } else {
            // Filter categories based on search input
            const filtered = filterCategories.filter((category) =>
                category.card_name
                    .toLowerCase()
                    .includes(filterSearchInput.toLowerCase())
            );
            setFilteredCategories(filtered);
        }
    }, [filterSearchInput, filterCategories]);
    const fetchFilterCardCategories = async () => {
        try {
            const res = await GetRequest(
                `common/fetchFilterCard/${customer.customer_details?.customer_id}/quotation?offset=${filterOffset}&limit=${filterLimit}&search=${debouncedFilterSearch}`,
                { headers },
                { customer, setCustomer, rf: headers.Authentication, navigate }
            );

            if (res.status === "fail" || res.success === false) {
                return;
            }

            setFilterCategories(res.data);

            // Calculate page count if total_count is available in response
            if (res.total_count) {
                setFilterPageCount(Math.ceil(res.total_count / filterLimit));
            }
        } catch (error) {
            toast.error("Error fetching filters");
        }
    };

    // New function to fetch deals
    const fetchDeals = async () => {
        const res = await GetRequest(
            `common/fetchAllDeals/${customer.customer_details?.customer_id}/${customer.customer_details?.id}`,
            { headers },
            { customer, setCustomer, rf: headers.Authentication, navigate }
        );
        if (!res) return;
        if (res.success === false) return;

        setDeals(
            res.data?.map((c) => ({
                deal: c.deal_name + " " + `(${c.deal_no})`,
                id: c.id,
            }))
        );
    };

    // New function to fetch approval count data
    const fetchApprovalCountData = async () => {
        try {
            const res = await GetRequest(
                `quotation/fetchMyApprovals/${customer_id}/${customer?.customer_details?.id}`,
                { headers },
                extras
            );
            if (res && res.data) {
                const count = res.total_count || res.data.length || 0;
                setApprovalCount(count);
            }
        } catch (e) {
            console.error("Error fetching approval count", e);
        }
    };

    // New function to initialize all data
    const initData = async () => {
        try {
            await Promise.all([
                fetchFilterCardCategories(),
                // fetchContacts(),
                // fetchCompanies(),
                // fetchLeadOwners(),
                fetchDeals(),
                fetchApprovalCountData(),
            ]);
        } catch (error) {
            console.error("Error initializing data", error);
        }
    };

    // Single useEffect to initialize all data
    useEffect(() => {
        initData();
    }, []);
    // edit handler for filter heading
    const handleFilterEdit = async () => {
        try {
            if (editValue === "") return;
            if (filterData === null) return;
            const updatePayload = {
                customer_id: customer.customer_details?.customer_id,
                user_login_id: customer.customer_details?.id,
                filter_id: filterData.id,
                card_name: editValue,
                description: "",
            };
            const res = await PutRequest(
                "contacts/updateFilterName",
                updatePayload,
                { headers },
                { customer, setCustomer, rf: headers.Authentication, navigate }
            );
            if (res.status === false || res.success === "fail") {
                setFilterDropdown(false);
                return;
            }
            if (res.status === "success") {
                setEditingId(null);
                fetchFilterCardCategories({
                    customer_id,
                    headers,
                    extras,
                    setState: { setFilterCategories },
                    setFilterPageCount,
                    filterLimit,
                    filterLimit,
                    debouncedFilterSearch,
                    filterOffset
                });
                setFilterDropdown(false);
            }
        } catch (error) {
            toast.error("Error Updating Filter");
        }
    };
    // delete handler for filter delete
    const handleFilterDelete = async () => {
        setLoading(true)
        try {
            if (filterData === null) return;
            const res = await DeleteRequest(
                `common/deleteFilter/${filterData.id}`,
                { headers },
                { customer, setCustomer, rf: headers.Authentication, navigate }
            );
            if (res.status === "fail") {
                setLoading(false)
                toast.error(res.message);
                return;
            }
            if (res.success === false) {
                setLoading(false)
                toast.error(res.message);
            }
            setLoading(false)
            setFilterDropdown(false);
            setFilterDelete(false);
            setHeading("All Quotations");
            fetchFilterCardCategories({
                customer_id,
                headers,
                extras,
                setState: { setFilterCategories },
                setFilterPageCount,
                filterLimit,
                filterLimit,
                debouncedFilterSearch,
                filterOffset
            });
            localStorage.setItem("quotation_last_heading", "All Quotations");
            toast.success(res.message);
        } catch (error) {
            toast.error("Error Deleting Filter");
        }
    };

    const handleFilterPageChange = (newOffset) => {
        setFilterOffset(newOffset.selected);
    };

    const handleMyApprovalClick = () => {
        setMyApproval(true);
        localStorage.setItem("quotation_isMyApproval", "true");
    };
    return (
        <div className="my-4 py-3 pb-1 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2">
                <h3
                    className="mb-0 d-flex gap-2 align-items-center"
                    style={
                        isMyApproval
                            ? {
                                cursor: "pointer",
                                fontWeight: 300,
                                fontSize: "22px",
                                color: "rgb(154 170 183)",
                            }
                            : {
                                whiteSpace: "nowrap",
                                fontWeight: 300,
                                fontSize: "22px",
                                cursor: "pointer",
                                textTransform: "capitalize",
                                color: "#4dabf4",
                            }
                    }
                    onClick={() => {
                        setMyApproval(false);
                        setHeading("All Quotations");
                        localStorage.setItem("quotation_isMyApproval", "false");
                        localStorage.setItem("quotation_last_heading", "All Quotations");
                        setFilterCategoriesDrop(false);
                    }}
                >
                    {lastHeading !== null && lastHeading !== undefined
                        ? lastHeading
                        : "All Quotations"}
                </h3>

                <ManageListDropdown
                    heading={heading}
                    setHeading={setHeading}
                    categories={filterCategories}
                    storageKey="quotation_last_heading"
                    setTempFilterData={setTempFilterData}
                    onEdit={(c) => setFilterData(c)}
                    onDelete={(c) => {
                        setFilterData(c)
                        setFilterDelete(true)
                    }}
                    onUpdate={(c) => {
                        setFilterData(c)
                        handleFilterEdit()
                    }}
                    staticOptions={quotationStaticListOptions}
                    filterOffset={filterOffset}
                    setFilterOffset={setFilterOffset}
                    handleFilterPageChange={handleFilterPageChange}
                    filterPageCount={filterPageCount}
                    filterLimit={filterLimit}
                />

                <p
                    style={{ width: 1, height: 25, background: "lightblue" }}
                    className="mb-0"
                ></p>
                <span
                    style={
                        isMyApproval
                            ? {
                                whiteSpace: "nowrap",
                                fontWeight: 300,
                                cursor: "pointer",
                                color: "#4dabf4",
                            }
                            : {
                                cursor: "pointer",
                                fontWeight: 300,
                                color: "rgb(154 170 183)",
                            }
                    }
                    onClick={() => handleMyApprovalClick()}
                >
                    <span style={{ fontSize: "22px" }}> My Approvals</span>{" "}
                    {approvalCount >= 0 && (
                        <>
                            {/* Notification Bell Container */}
                            <div
                                className="position-relative d-inline-flex align-items-center justify-content-center"
                                style={{ cursor: "pointer" }}
                            >
                                {/* The Bell Icon */}
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="#656565"
                                    style={{ width: "20px", height: "20px" }}
                                >
                                    <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
                                </svg>

                                {/* The Count Badge */}
                                {approvalCount >= 0 && (
                                    <span
                                        className="badge rounded-pill bg-success d-flex align-items-center justify-content-center"
                                        style={{
                                            position: "absolute",
                                            top: "-9px",
                                            right: "-7px",
                                            fontSize: "7px",
                                            minWidth: "16px",
                                            height: "16px",
                                            padding: "0 4px",
                                            border: "1px solid white",
                                        }}
                                    >
                                        {approvalCount}
                                    </span>
                                )}
                            </div>
                        </>
                    )}
                </span>

                {confirmFilterDelete && (
                    <DeleteModal
                        show={confirmFilterDelete}
                        onClose={() => setFilterDelete(false)}
                        onConfirm={() => handleFilterDelete(filterData)}
                        message="Are you sure you want to delete this item?"
                        isLoading={loading}
                    ></DeleteModal>
                )}
            </div>

            <div
                className="d-flex align-items-center gap-1"
                style={{ height: "39px" }}
            >
                {/* search bar */}
                <div className=" position-relative">
                    <input
                        type="text"
                        style={{ fontSize: "12px", paddingLeft: "36px", height: "35px" }}
                        className="form-control "
                        value={inputSearch}
                        onChange={(e) => {
                            setInputSearch(e.target.value);
                            setActiveOffset(0);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                setSearch(inputSearch);
                                setActiveOffset(0);
                            }
                        }}
                    />
                    <i
                        class="fa-solid fa-magnifying-glass"
                        style={{
                            position: "absolute",
                            marginTop: "-26px",
                            zIndex: 1,
                            marginLeft: "13px",
                        }}
                    ></i>
                    {inputSearch.length > 0 && (
                        <i
                            class="fa-solid fa-xmark"
                            style={{
                                position: "absolute",
                                marginTop: "-26px",
                                zIndex: 1,
                                right: 0,
                                marginRight: "13px",
                                cursor: "pointer",
                            }}
                            onClick={() => setInputSearch("")}
                        ></i>
                    )}
                </div>

                {/* advance filtering */}
                <Filter
                    filterDropdown={filterDropdown}
                    setFilterDropdown={setFilterDropdown}
                    dropdownOptions={dropdownOptions}
                    filterState={filterStates}
                    setFilterState={setFilterState}
                    setHeading={setHeading}
                    subFilter={subFilter}
                    module_name={"quotation"}
                    customSubFilter={customSubFilter}
                    setTempFilterData={setTempFilterData}
                    filterEndpoint={"common/filterQuery"}
                    applyQuery={"quotation/applyFilter"}
                    view={"list"}
                ></Filter>

                <ColumnConfigurator
                    columnOptions={columnOptions}
                    columns={columns}
                    setColumns={setColumns}
                    storageKey="quotationColumns"
                    visibleKey="visibleQuotationColumns"
                />

                <Dropdown
                    as="div"
                    className="dropdownsWithoutToggle"
                    style={{ zIndex: 101 }}
                >
                    <Dropdown.Toggle as={Nav.Link} className="header-link">
                        <button
                            className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                            style={{
                                fontSize: "1rem",
                                alignItems: "center",
                                height: "35px",
                                width: "2.5rem",
                            }}
                        >
                            {" "}
                            <FontAwesomeIcon
                                style={{
                                    width: "15px",
                                    height: "15px",
                                }}
                                icon={faEllipsisVertical}
                            />
                        </button>
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                        className="defaultDropdown dropdown-menu-end "
                        style={{ width: "11rem", padding: "12px 0px", right: "3.4rem" }}
                    >
                        <Dropdown.Item
                            onClick={() => {
                                if (!quotationGrant?.isImport) {
                                    toast.warning("You are not authorized for this action!");
                                    return;
                                }
                                navigate("/importdata", {
                                    state: {
                                        module_name: "quotation",
                                        fieldData: [
                                            {
                                                title: "General Fields",
                                                fields: quotationImportFields?.map((c) => c),
                                            },
                                        ],
                                    },
                                });
                            }}
                            href="#"
                            className="d-flex align-items-center"
                        >
                            <FontAwesomeIcon
                                icon={faFileImport}
                                style={{
                                    width: "16px",
                                    height: "16px",
                                    marginRight: "9px",
                                    color: "#5e5f60",
                                }}
                            />{" "}
                            Import Data
                        </Dropdown.Item>
                        <Dropdown.Item
                            className="d-flex align-items-center"
                            onClick={() => {
                                if (!quotationGrant?.isExport) {
                                    toast.warning("You are not authorized for this actions!");
                                    return;
                                }
                                handleExportData([], "quotation", headers, extras);
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faFileExport}
                                style={{
                                    width: "16px",
                                    height: "16px",
                                    marginRight: "9px",
                                    color: "#5e5f60",
                                }}
                            />{" "}
                            Export Data
                        </Dropdown.Item>
                        <Dropdown.Item href="#" className="d-flex align-items-center">
                            <FontAwesomeIcon
                                icon={faFileCsv}
                                style={{
                                    width: "16px",
                                    height: "16px",
                                    marginRight: "9px",
                                    color: "#5e5f60",
                                }}
                            />{" "}
                            Template
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                <Button
                    type="button"
                    className="btn btn-default"
                    style={{
                        height: "33px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => {
                        if (!quotationGrant?.isCreate) {
                            toast.warning("You are not authorized for this action!");
                            return;
                        }
                        navigate("/createQuotation");
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} className="pe-1" /> Add
                </Button>
            </div >
        </div >
    )
}
